import { call, put, takeEvery } from 'redux-saga/effects';
import { profileActions } from './profileSlice';
import { getProfileInfo, updateProfile } from './profileBaseAPi';
import { toastAction } from '../toast/toast';

export function* onChangeProfile(payload) {
    try {
        const { data } = yield call(getProfileInfo, payload);
        if (data.student) {
            yield put(profileActions.setProfile(data.student || {}));
            localStorage.setItem('profile', JSON.stringify(data.student));
        } else if (data.teacher) {
            yield put(profileActions.setProfile(data.teacher || {}));
            localStorage.setItem('profile', JSON.stringify(data.teacher));
        }
    } catch (error) {
        // yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

export function* onChangeProfileData({ payload }) {
    try {
        const { data } = yield call(updateProfile, payload);
        let profile = JSON.parse(localStorage.getItem('profile'))
        let profileTemp = { ...profile, gradeLevel: payload?.body?.gradeLevel }
        yield put(profileActions.updateProfile(payload || {}));
        localStorage.setItem('profile', JSON.stringify(profileTemp))
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

function* profileWatcherSaga() {
    yield takeEvery(profileActions.loadProfile.type, onChangeProfile);
    yield takeEvery(profileActions.changeProfile.type, onChangeProfileData);
}

export default profileWatcherSaga;